import { z } from 'zod';

export const MOMENT_SETTINGS_DEFAULTS = {
  retentionHours: 72,
  configIdleRetentionHours: 168,
  minDecisionIntervalMinutes: 30,
};

const hours = z.number().int().min(1).max(Number.MAX_SAFE_INTEGER);
export const momentSettingsSchema = z.object({
  retentionHours: hours.default(MOMENT_SETTINGS_DEFAULTS.retentionHours),
  configIdleRetentionHours: hours.default(MOMENT_SETTINGS_DEFAULTS.configIdleRetentionHours),
  minDecisionIntervalMinutes: z.number().int().min(1).max(1440).default(MOMENT_SETTINGS_DEFAULTS.minDecisionIntervalMinutes),
}).strict().prefault({});
